import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { createTheme } from '@mui/material/styles';
import queryString from 'query-string';
// import { useNavigate } from "react-router-dom";

import SessionPageFrame from '../components/SessionPageFrame.js';
import PanelHeader from '../components/PanelHeader.js';
import ApiCall from '../components/ApiCall.js';
import themeSettings from '../theme.js';

import constants from '../constants.js';
// import andopen from './andopen.svg';

const theme = createTheme(themeSettings);

export default function RequestNewPassword() {
  const qs = queryString.parse(window.location.search);
  const qsemail = qs.email;

  // const [error, setError] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [processing, setProcessing] = React.useState(false);

  function handleForgot(email){
    setProcessing(true);
    const options = {
      url: `/user/${email}/action/get-password-token`,
      headers: {},
      body: {},
      method: 'post',
      maxRedirects: 1,
      responseType: 'json',
      withCredentials: true
    };
    ApiCall(options, (e, r) => {
      setProcessing(false);
      setSubmitted(true);
    });
  }

  function SubmittedPanel(){
    return (
      <Box style={{
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.light,
        padding: '20px',
        width: `${constants.panelWidth}px`
        }}>
        <Typography component="h1" variant="h4" color={theme.palette.primary.light}>
          Check your inbox
        </Typography>
        <Typography component="h1" variant="subtitle1" style={{ lineHeight: 1.2, margin: 20, opacity: 0.8 }}  color={theme.palette.primary.light}>
          If the email address you provided matches the address of an &Open Developer account, we will send you a password reset link by email.
          <p>Go to <Link color="inherit" href="https://developers.andopen.co/">developers.andopen.co</Link>
          </p>
        </Typography>
      </Box>
    )
  }

  function ResetPanel({ message }){
    const [email, setEmail] = React.useState(qs.email || '');

    return (
      <PanelHeader ribbon={true} message={`New Password Request`} >
        <Box
          noValidate
          sx={{ mt: 1 }}
          style={{
            paddingLeft: '30px',
            paddingRight: '30px',
            paddingTop: '10px',
            paddingBottom: '20px',
            borderRadius: '4px'
          }}>

          <TextField
            margin="normal"
            required
            fullWidth
            label="Email Address"
            autoFocus

            defaultValue={qsemail}
            id="email"
            name="email"
            autoComplete="email"
            disabled={processing}

            onChange={e => setEmail(e.target.value)}
            />
          <Button
            onClick={() => handleForgot(email)}
            fullWidth
            variant="contained"
            disabled={processing || !email}
            sx={{
              mt: 3, mb: 2,
            }}>
            Request password reset link
          </Button>
        </Box>

        <Box
          noValidate
          sx={{ mt: 1 }}
          style={{
            paddingLeft: '30px',
            paddingRight: '30px',
            paddingBottom: '20px',
          }}>

          <Grid container direction="column">
            <Grid item>
              <Grid container direction="row">
                <Grid item>
                  <Link href={`sign-in?email=${email}`} variant="body2" color={theme.palette.primary.dark}>
                    Sign In
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

      </PanelHeader>
    )
  }


  return (
    <SessionPageFrame>
      {
        submitted
        ? <SubmittedPanel />
        : <ResetPanel />
      }
    </SessionPageFrame>
  );
}